import { SimpleCallback } from 'platform-components/common';
import { TEXT_MARKUP_TYPE } from 'platform-components/constants';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { ConfirmationDialog } from 'common.components/confirmation-dialog/confirmation-dialog';
import { getIsOnlyTeacherInCurrentClass } from 'common.components/user/selectors';
import { getTrimmedName } from 'utils/get-trimmed-name';

import { ReduxTeacherStore } from '../../../typings';

interface OwnProps {
    classId: number;
    level?: number;
    name?: string;
    onClose: SimpleCallback;
    onConfirm: SimpleCallback;
    onReject: SimpleCallback;
    opened: boolean;
}

type StoreProps = ReturnType<typeof mapStateToProps>;

interface Props extends OwnProps, StoreProps {}

class DeleteClassModal extends React.Component<Props> {
    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };

    render() {
        const { level, name, onClose, onConfirm, onReject, opened, shouldWarn } = this.props;

        return (
            <ConfirmationDialog
                closable
                confirmLabelId="deleteClassConfirmation.confirm"
                headerId="deleteClassConfirmation.title"
                headerType={TEXT_MARKUP_TYPE.HTML}
                headerValues={{ name: getTrimmedName(name), level }}
                messageId={shouldWarn ? 'deleteClassConfirmation.messageWarn' : 'deleteClassConfirmation.message'}
                messageType={TEXT_MARKUP_TYPE.HTML}
                messageValues={{ level }}
                onClose={onClose}
                onConfirm={onConfirm}
                onReject={onReject}
                opened={opened}
                rejectLabelId="deleteClassConfirmation.cancel"
                theme={ConfirmationDialog.THEMES.YANDEX}
            />
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, { classId }: OwnProps) => ({
    shouldWarn: !getIsOnlyTeacherInCurrentClass(storeState, { classId }),
});

export default connect(mapStateToProps)(DeleteClassModal);
